import { Grid, Stack } from "@mui/material";
import { CaseInfoItem } from "@/features/case/components/CaseBasicInfo/CaseInfoItem";
import { Button } from "@/components/elements/Button";
import { TGetJobDto } from "@/api/services/main/job/dtos/get-job.dto";
import { FCC } from "@/types/common";
import { Link } from "react-router-dom";
import { AppRoutes } from "@/routes/config";
import { findLabelByValue } from "@/utils/object";
import { useEnum } from "@/api/services/global/enum";

type TCaseRequestInfoProps = {
  jobInfo: TGetJobDto;
};

export const CaseRequestInfo: FCC<TCaseRequestInfoProps> = ({ jobInfo }) => {
  const { id, gender, skillsExperience, japaneseLevelType, japaneseLevelOther, nationalities } = jobInfo;
  const urlJobDetail = AppRoutes.jobEdit.replaceAll(":jobId", String(id));
  const nationalitiesList = nationalities?.map((nationality) => nationality.nationalityName).join("、");
  const { data: genderOptions } = useEnum("EGender");

  return (
    <Grid container spacing={2} p={2}>
      <Grid item xs={6}>
        <CaseInfoItem label="国籍" value={nationalitiesList} />
      </Grid>
      <Grid item xs={6}>
        <CaseInfoItem label="性別" value={findLabelByValue(genderOptions, gender)} />
      </Grid>
      <Grid item xs={6}>
        <CaseInfoItem label="必要な技能・経験" value={skillsExperience} />
      </Grid>
      <Grid item xs={6}>
        <CaseInfoItem label="必要な日本語レベル" value={japaneseLevelType} />
      </Grid>
      <Grid item xs={12}>
        <CaseInfoItem label="必要な日本語レベル（その他）" value={japaneseLevelOther} />
      </Grid>
      <Grid item xs={12}>
        <Stack direction="row" spacing={2} justifyContent={"end"}>
          <Button component={Link} to={urlJobDetail} variant="ghost" target="_blank">
            詳細を見る
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};
